<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div v-if="dataLoaded" class="ret-cards-wrapper">
      <v-card class="ret-card">
        <v-card-title>
          <h3 class="headline">{{ $tc('planned-issues.entity-name', 1) }}</h3>
          <v-spacer></v-spacer>
          <v-btn v-if="editedItem.id" text color="warn" @click="onDestroy(editedItem)" data-test="archive">{{ $t('archive') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <form @keyup.enter="handleSaveClick">
            <v-autocomplete clearable hide-no-data no-filter
              v-model="editedItem.assetTypeId"
              item-text="name"
              item-value="id"
              :label="$tc('asset-types.entity-name', 1)"
              :items="lazySelect['asset-types'].listItems"
              :search-input.sync="lazySelect['asset-types'].search"
              :loading="lazySelect['asset-types'].loading"
              @focus="updateLazySelect({ model: 'asset-types' })"
              data-test="asset-type"
            ></v-autocomplete>

            <v-combobox
              v-model="selectedIssueCode"
              :items="issueCodes" @blur="onCodeBlur"
              :label="$t('code')" :error-messages="itemErrors.code"
              :search-input.sync="searchIssueCode"
              :filter="filterIssueCodes"
              hide-selected
              clearable
              menu-props="closeOnContentClick"
              @keyup.8.prevent="selectedIssueCode = null"
              data-test="issue-code">
              <template slot="no-data">
                <v-list-item>
                  <span class="subtitle-1">{{ noDataValue }}</span>
                </v-list-item>
              </template>
              <template slot="item" slot-scope="{ index, item }">
                <v-list-item-content>
                  <span class="subtitle-1">[{{ item.code }}] {{ item.name }}</span>
                </v-list-item-content>
              </template>
              <template slot="selection" slot-scope="{ item }">
                {{ item.code }}
              </template>
            </v-combobox>
            <v-text-field v-model="editedItem.name" :label="$t('problem-description')" data-test="description"></v-text-field>

            <v-text-field
              type="number"
              step="1"
              min="0"
              v-model="editedItem.period"
              :label="$t('period-days')"
              :error-messages="itemErrors.period"
              data-test="period"
            ></v-text-field>

            <v-layout row wrap>
              <v-flex xs12 sm4>
                <!-- This field is disabled as it will always be set by BE as true -->
                <v-switch hide-details v-model="editedItem.maintenance" :label="$t('maintenance')" disabled data-test="maintenance"></v-switch>
              </v-flex>
              <v-flex xs12 sm4 v-if="$cans('prg')">
                <v-radio-group v-model="editedItem.category">
                  <v-radio label="Elektronika" value="E"></v-radio>
                  <v-radio label="Mechanika" value="M"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 sm4 v-if="$cans('prg')">
                <v-radio-group v-model="editedItem.account">
                  <v-radio label="Záruka" value="záruka"></v-radio>
                  <v-radio label="Paušál" value="paušál"></v-radio>
                  <v-radio label="Fakturace" value="fakturace"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="$router.go(-1)" data-test="back">{{ $t('back') }}</v-btn>
          <v-spacer />
          <v-btn @click="handleSaveClick" color="primary" :disabled="!isUnsaved" data-test="save">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import itemHelpers from '../helpers/item-helpers.es6'
import lazySelects from '../helpers/lazy-selects.es6'

export default {
  mixins: [itemHelpers, lazySelects],
  data () {
    return {
      model: { name: 'planned-issue-definitions' },
      auxModels: [
        { name: 'issue-codes' }
      ],
      selectedIssueCode: null,
      searchIssueCode: null,
      autocomplete: [
        { model: 'asset-types', value: 'editedItem.assetTypeId' }
      ]
    }
  },
  computed: {
    issueCodes () {
      return this.$store.state.items['issue-codes']
    },
    noDataValue () {
      if (this.selectedIssueCode && this.selectedIssueCode.code) {
        if (!!this.selectedIssueCode.name || this.selectedIssueCode.name === '') {
          return `[${this.selectedIssueCode.code}] ${this.selectedIssueCode.name}`
        }
        return `${this.$t('create')} "${this.selectedIssueCode.code}"`
      }
      return `${this.$t('create')} "${this.searchIssueCode}"`
    }
  },
  methods: {
    // FE Actions
    onCodeBlur () {
      if (this.selectedIssueCode && this.selectedIssueCode.code) {
        this.editedItem.code = this.selectedIssueCode.code
      } else if (this.searchIssueCode) {
        this.editedItem.code = this.searchIssueCode
      }

      if (!this.editedItem.name) {
        let issueCode = this.issueCodes.find(i => i.code === this.editedItem.code)
        if (issueCode) {
          // Must be done via store as otherwise does not work for /new (having item just {})
          this.$store.commit('modifyItem', { modelName: this.model.name, col: 'name', val: issueCode.name })
        }
      }
    },
    filterIssueCodes (item, queryText, itemText) {
      const actualItemText = `[${itemText.code}] ${itemText.name}`.toLowerCase()
      return actualItemText.indexOf(queryText.toString().toLowerCase()) > -1
    }
  },
  watch: {
    selectedIssueCode (val, prev) {
      if (typeof val === 'string') {
        this.selectedIssueCode = {
          code: val
        }
      }
    },
    dataLoaded (val) {
      if (val && this.item.code) {
        this.selectedIssueCode = `${this.item.code}`
      }
    }
  }
}
</script>
